// export default () => ({
// })

export default () => ({
    dealers: [],
    dealersSelectable: [],
    dealersPaginatedData: null,
    dealer: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})